import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ShowRelatedProjectsComponent } from './show-related-projects.component';

@NgModule({
    imports: [TwcModule, CommonModule, TranslateModule],
    declarations: [ShowRelatedProjectsComponent],
    exports: [ShowRelatedProjectsComponent],
})
export class ShowRelatedProjectsModule {}
